import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11697_16017",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "25",
      height: "24"
    }, [
      _createElementVNode("rect", {
        x: "0.5",
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11697_16017)" }, [
      _createElementVNode("path", {
        d: "M3.5 21V16H5.5V19H8.5V21H3.5ZM16.5 21V19H19.5V16H21.5V21H16.5ZM3.5 8V3H8.5V5H5.5V8H3.5ZM19.5 8V5H16.5V3H21.5V8H19.5Z",
        fill: "#17346D"
      })
    ], -1)
  ]))]))
}
export default { render: render }